<mat-card class="content-card">

  <div fxLayout="row" style="">
    <div fxFlex="40">
      <span (click)="returnBack()" style="cursor: pointer; margin-right: 15px;">◀️ Go back</span>

    </div>
    <div fxFlex="60" class="text-right">
      <h3>{{ fileName }}</h3>
    </div>


  </div>


    <div style="height: 30px;">&nbsp;</div>


    <div *ngIf="previewFileOpen">
      <iframe class="resp-iframe" height="1000" width="100%" frameBorder="1" *ngIf="this.previewType === 1" [src]="previewUrlSafe" ></iframe>
      <img [src]="previewUrlSafe" style="margin-left: auto; margin-right: auto; display: block; max-width: 100%; height:auto;" *ngIf="this.previewType === 2" />
    </div>


  <div style="height: 30px;">&nbsp;</div>



</mat-card>
